// extracted by mini-css-extract-plugin
export default {"list":"CardsListVirtualizer_list__t0Zr-","row":"CardsListVirtualizer_row__q-yS4"};